import { DoubleCard } from '@/cms/DoubleCard';
import { DoubleCardWide } from '@/cms/DoubleCardWide';
import { FourColumnScroll } from '@/cms/FourColumnScroll';
import { MyAccountCardGroup } from '@/cms/MyAccountCardGroup';
import { SliderFullwidthGallery } from '@/cms/SliderFullwidthGallery/SliderFullwidthGallery';
import { SliderMaxFourCards } from '@/cms/SliderMaxFourCards/SliderMaxFourCards';
import { ThreeColumnScroll } from '@/cms/ThreeColumnScroll';
import { ThreeColumnStack } from '@/cms/ThreeColumnStack';
import { ThreeColumnTeaser } from '@/cms/ThreeColumnTeaser';
import { SinceHistory } from '@/components/SinceHistory/SinceHistory';
import type { ContentGroupType } from '@/integrations/contentful';

import type { ContentGroupProps } from './ContentGroup';

export const renderContentfulContentGroupSection = (
  _props: ContentGroupProps,
) => {
  const typename = _props?.type as ContentGroupType;
  switch (typename) {
    case 'DoubleCard':
      return <DoubleCard {..._props}></DoubleCard>;
    case 'DoubleCardWide':
      return <DoubleCardWide {..._props}></DoubleCardWide>;
    case 'ThreeColumnTeaser':
      return <ThreeColumnTeaser {..._props}></ThreeColumnTeaser>;
    case 'ThreeColumnStack':
      return <ThreeColumnStack {..._props}></ThreeColumnStack>;
    case 'ThreeColumnScroll':
      return <ThreeColumnScroll {..._props}></ThreeColumnScroll>;
    case 'FourColumnScroll':
      return <FourColumnScroll {..._props}></FourColumnScroll>;
    case 'MyAccountCardGroup':
      return <MyAccountCardGroup {..._props}></MyAccountCardGroup>;
    case 'HistoriesTwoColumn':
      return <SinceHistory {..._props}></SinceHistory>;
    case 'SliderFullwidthGallery':
      return <SliderFullwidthGallery {..._props}></SliderFullwidthGallery>;
    case 'SliderMaxFourCards':
      return <SliderMaxFourCards {..._props}></SliderMaxFourCards>;
    default:
      return null;
  }
};
